<template>
  <div id="xuliehao">
    <div class="tableheader">
      <el-button @click="getList(1)" class="btn3" type="primary">{{ $t("search") }}</el-button>
      <el-input v-model="code" class="codeshearch" size="small" :placeholder="$i18n.t('xunliema').searchkey"></el-input>
    </div>
    <div class="deviceAddBlock">
      <el-table :data="lists" style="width: 100%">
        <el-table-column :label="$i18n.t('xunliema').tablefiled[0]" width="100">
          <template slot-scope="scope">
            {{ scope.row.device_no }}{{ scope.row.is_bind == 1 ? '(已绑定)' : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="model" :label="$i18n.t('xunliema').tablefiled[1]" width="120"></el-table-column>
        <el-table-column prop="mac" :label="$i18n.t('xunliema').tablefiled[2]" width="140"></el-table-column>
        <el-table-column prop="serial" :label="$i18n.t('xunliema').tablefiled[4]" width="130"></el-table-column>
        <el-table-column prop="app_version" :label="$i18n.t('xunliema').tablefiled[3]" width="80"></el-table-column>
        <el-table-column prop="ip" :label="$i18n.t('xunliema').tablefiled[5]" width="180"></el-table-column>
        <el-table-column prop="location" :label="$i18n.t('xunliema').tablefiled[6]" width="180"></el-table-column>
        <el-table-column :label="$i18n.t('xunliema').tablefiled[7]" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 10" style="color: green;">{{ $t('xunliema').status[0] }}</span>
            <span v-else-if="scope.row.status == -11" style="color: red;">{{ $t('xunliema').status[1] }}</span>
            <span style="color: #fc5531;" v-else>{{ $t('xunliema').status[2] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="crt_time" :label="$i18n.t('xunliema').tablefiled[8]" width="180"></el-table-column>
        <el-table-column prop="last_open_time" :label="$i18n.t('xunliema').tablefiled[9]"></el-table-column>
        <el-table-column prop="comment" :label="$i18n.t('xunliema').tablefiled[10]" width="100"></el-table-column>
        <el-table-column :label="$i18n.t('xunliema').tablefiled[11]" width="250" fixed="right">
          <template slot-scope="scope">
            <el-button @click="showMark(scope.row.id, scope.row.comment, scope.row.status)" class="btn3"
              type="primary">备注</el-button>
            <!-- <el-button v-if="scope.row.is_bind == 1" @click="unbind(scope.row.device_no)" class="btn3"
              type="primary" style="margin-right: 0.1rem;">解绑</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="getList" style="margin-top: 0.2rem;" background layout="prev, pager, next"
        :total="total" :page-size="pageSize" :current-page.sync="pageNo"> </el-pagination>
    </div>
    <el-dialog width="25%" :title="$i18n.t('xunliema').form.title" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item :label="$i18n.t('xunliema').tablefiled[7]" :label-width="formLabelWidth">
          <el-select v-model="form.status" placeholder="请选择">
            <el-option :label="$i18n.t('xunliema').status[0]" :value="10"></el-option>
            <el-option :label="$i18n.t('xunliema').status[1]" :value="-11"></el-option>
            <el-option :label="$i18n.t('xunliema').status[2]" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$i18n.t('xunliema').form.name" :label-width="formLabelWidth">
          <el-input v-model="form.mark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('xunliemaask').form.cancle }}</el-button>
        <el-button type="primary" @click="toMark()">{{ $t('xunliemaask').form.sure }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'xuliehao',
  data() {
    return {
      doing: false,
      code: '',
      lists: null,
      dialogVisible: false,
      info: {},
      total: 0,
      pageSize: 15,
      pageNo: 1,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      form: {
        id: '',
        mark: '',
        status: -1,
      }
    }
  },
  computed: {

  },
  created() {
    this.getList(1)
  },
  methods: {
    unbind(device_no){
      if(this.doing === true){
        return false
      }
      this.doing = true
      let _this = this
      this.axios.post('/skinMgrSrv/device/unbindZmActiveCode', this.formData({code: device_no})).then(function (response) {
        _this.doing = false
        if(response.data.code === 0){
          _this.$message.success('解绑成功')
          _this.getList(_this.pageNo)
        }
      })
    },
    getList(val) {
      if (this.doing === true) {
        return false
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true
      let _this = this
      _this.pageNo = val
      let data = { search: this.code, pageSize: this.pageSize, pageNo: this.pageNo }
      this.axios.post('/skinMgrSrv/device/serialList', this.formData(data)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.lists = response.data.list
          _this.total = parseInt(response.data.total)
        }
        setTimeout(() => {
          dataLoadIng.close()
        }, 500);
      })
    },
    showMark(id, mark, status) {
      this.form.mark = mark
      this.form.id = id
      this.form.status = status ? parseInt(status) : -1
      this.dialogFormVisible = true
    },
    toMark() {
      if (this.form.mark == '') {
        this.$message(this.$i18n.t('xunliema').warns[0])
        return false
      }
      this.doing = true
      let _this = this
      this.axios.post('/skinMgrSrv/device/serialMark', this.formData(this.form)).then(function (response) {
        _this.doing = false
        if (response.data.code === 0) {
          _this.dialogFormVisible = false
          _this.getList(_this.pageNo)
        }
      })
    }
  }
}
</script>
<style lang="scss">
#xuliehao {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }

    .el-card {
      cursor: pointer;
    }

    .el-card:hover {
      border: $blue 1px solid;
    }
  }

  .el-dialog__header {
    border-bottom: #E9E9E9 1px solid !important;
  }

  .el-button--mini,
  .el-button--mini.is-round {
    padding: 7px 0.0833rem;
  }

  .el-button--primary {
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
  }

  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #fff;
    background-color: #57AEC9;
    border-color: #57AEC9;
    -webkit-box-shadow: -1px 0 0 0 #57AEC9;
    box-shadow: -1px 0 0 0 #57AEC9;
  }

  .el-table th>.cell {
    text-align: center;
  }
}
</style>

<style scoped lang="scss">
#xuliehao {
  padding: 0.1667rem;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0.04166rem;
  margin: 0.1667rem;

  p.title {
    height: 0.4167rem;
    line-height: 0.4167rem;
    font-size: 0.15rem;
    color: #000;
  }

  .btn2,
  .btn3 {
    padding: 0.0667rem 0.0833rem;
  }

  .codeshearch {
    width: 1.667rem;
    margin-right: 0.1rem;
  }

  .btn3,
  .codeshearch {
    float: right;
  }

  .deviceAddBlock {
    text-align: center;
    margin-top: 0.0833rem;
  }

  .warncolor {
    color: red;
  }

  .greencolor {
    color: green;
  }
}
</style>



// WEBPACK FOOTER //
// src/device/xuliema.vue